module.exports = "/_next/static/images/OgSegmentVsOtherCdps-b5c71c7177d51912ec5b18a69c31b878.png";